module.exports = __webpack_public_path__ + "static/media/icon-7eleven.5943c7ff.png";